import Alarm from 'components/Common/Alarm/Alarm';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import InverterHomePage from './pages/InverterHomePage/InverterHomePage';
import Parameter from './pages/Parameter/Parameter';
// import ManagementUser from './pages/Management/Management';

export default function InverterFeature() {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/home/:id`} exact>
        <InverterHomePage />
      </Route>
      <Route path={`${match.path}/parameter/:id`} exact>
        <Parameter />
      </Route>
      <Route path={`${match.path}/alarm/:id`} exact>
        <Alarm />
      </Route>
    </Switch>
  );
}
